import { defineSmartFields } from '@hprofits/ui-smart-controls';
import { computed } from 'vue';

import { t } from '@/i18n';

import type { BlacklistRuleForm } from '../../../../api/blacklistAutoRuleContract';
import type { BlacklistDictionariesQuery } from '../../../../api/useBlacklistDictionaries';
import { checkPeriodMinFieldOptions } from '../../../../utils/checkPeriodMin';

export const useEditorFields = (dictionaries: BlacklistDictionariesQuery) =>
  computed(() => {
    const ff = defineSmartFields<BlacklistRuleForm>();
    const data = dictionaries.data.value;
    return [
      ff.text('name', {
        label: t('modules.blacklistAutoRules.name'),
        labelHint: t('modules.blacklistAutoRules.editor.nameHint'),
      }),
      ff.number('checkPeriodMin', checkPeriodMinFieldOptions()),
      ff.select.list('type', {
        label: t('modules.blacklistAutoRules.editor.type'),
        options: (data?.types ?? []).map((item) => ({ value: item.id, label: item.name })),
        // Rule type names run long ("Nurl Discrepance (Domain, Device, Country, IP)") — the
        // dropdown sizes to its content instead of truncating to the trigger's width.
        dropdownWidth: 'max-content',
      }),
      ff.select.list('actionState', {
        label: t('modules.blacklistAutoRules.editor.action'),
        labelHint: t('modules.blacklistAutoRules.editor.actionHint'),
        options: (data?.states ?? []).map((item) => ({ value: item.id, label: item.name })),
      }),
      ff.select.multi('banAdUnitTypeIds', {
        label: t('modules.blacklistAutoRules.editor.banAdUnitType'),
        labelHint: t('modules.blacklistAutoRules.editor.adUnitTypeModeHint'),
        options: (data?.adUnitTypes ?? []).map((item) => ({ value: item.id, label: item.name })),
      }),
    ];
  });
